/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Bo as Bo,
  rec_Componente_Qk_81_107 as Componente_Qk_81_107,
  rec_Componente_Zk_90_107 as Componente_Zk_90_107,
  rec_EstadoError as EstadoError,
  rec_Fo as Fo,
  rec_JSXRuntime as JSXRuntime,
  rec_Modal as Modal,
  rec_React as React,
  rec_api as api,
  rec_pS as pS,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function SesionesUsuario({ usuario: e, onClose: t }) {
  let { confirmar: n } = Fo(),
    [r, i] = (0, React.useState)([]),
    [a, o] = (0, React.useState)(!0),
    [s, c] = (0, React.useState)(``),
    l = (0, React.useCallback)(async () => {
      o(!0);
      try {
        (i(await api(`/dispositivos/usuario/${e.id}`)), c(``));
      } catch (e) {
        c(e.message);
      } finally {
        o(!1);
      }
    }, [e.id]);
  (0, React.useEffect)(() => {
    l();
  }, [l]);
  async function u(t) {
    if (
      await n({
        titulo: `Cerrar la sesión`,
        mensaje: `${t.descripcion || `Ese dispositivo`} va a tener que iniciar sesión de nuevo.`,
        confirmarTexto: `Cerrar sesión`,
        peligro: !0,
      })
    )
      try {
        (await api(`/dispositivos/usuario/${e.id}/${t.id}`, {
          method: `DELETE`,
        }),
          l());
      } catch (e) {
        c(e.message);
      }
  }
  let f = r.filter((e) => e.sesionActiva).length;
  return (
    <Modal
      titulo={`Dispositivos de ${e.usuario}`}
      onClose={t}
      children={
        <div
          className={`flex flex-col gap-3`}
          children={[
            <p
              className={`text-xs text-(--text)`}
              children={[
                f,
                ` `,
                f === 1 ? `sesión activa` : `sesiones activas`,
                ` de `,
                r.length,
                ` `,
                r.length === 1 ? `dispositivo` : `dispositivos`,
                `. Cerrar una sesión la corta al instante.`,
              ]}
            />,
            <EstadoError mensaje={s} onReintentar={l} />,
            a ? (
              <Componente_Zk_90_107 />
            ) : r.length === 0 ? (
              <Componente_Qk_81_107
                texto={`Esta persona todavía no inició sesión en ningún dispositivo.`}
              />
            ) : (
              <ul
                className={`flex flex-col gap-2`}
                children={r.map((e) => (
                  <li
                    key={e.id}
                    className={`${Bo} flex flex-wrap items-center gap-2`}
                    children={[
                      <div
                        className={`min-w-0 flex-1`}
                        children={[
                          <p
                            className={`truncate text-sm text-(--text-h)`}
                            children={
                              e.descripcion || `Dispositivo sin describir`
                            }
                          />,
                          <p
                            className={`text-[11px] text-(--text)`}
                            children={[
                              e.ip || `sin IP`,
                              ` · último uso `,
                              pS(e.fechaUltimoUso) || `—`,
                            ]}
                          />,
                          <p
                            className={`mt-1 flex flex-wrap gap-1 text-[10px]`}
                            children={[
                              e.sistema && <span className={`rounded-full bg-(--panel) px-2 py-0.5 text-(--text-h)`} children={e.sistema} />,
                              <span className={`rounded-full px-2 py-0.5 ${e.modo === `APP` ? `bg-(--accent-bg) text-(--accent)` : `bg-(--panel) text-(--text)`}`}
                                children={e.modo === `APP` ? `App instalada` : e.modo === `NAVEGADOR` ? `Navegador` : `Sin informar`} />,
                              <span className={`rounded-full px-2 py-0.5 ${e.avisosActivos ? `bg-(--success-bg) text-(--success)` : `bg-(--panel) text-(--text)`}`}
                                children={e.avisosActivos ? `Avisos activos` : `Sin avisos`} />,
                            ]}
                          />,
                        ]}
                      />,
                      e.sesionActiva && (
                        <span
                          className={`rounded-full border border-(--success-border) bg-(--success-bg) px-2 py-0.5 text-[10px] uppercase text-(--success)`}
                          children={`activa`}
                        />
                      ),
                      e.confiado && (
                        <span
                          className={`rounded-full border border-(--accent-border) bg-(--accent-bg) px-2 py-0.5 text-[10px] uppercase text-(--accent)`}
                          children={`confiado`}
                        />
                      ),
                      <button
                        type={`button`}
                        onClick={() => u(e)}
                        className={zo}
                        children={`Cerrar sesión`}
                      />,
                    ]}
                  />
                ))}
              />
            ),
          ]}
        />
      }
    />
  );
}
